import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import {
    GuidanceContext,
    GuidanceService,
} from '../providers/guidance.service';
import { HttpClient, HttpHeaders } from '@angular/common/http';

interface IGuidanceSettings {
    resource: string;
    title: string;
}

@Component({
    selector: 'app-guidance-drawer',
    templateUrl: './guidance-drawer.component.html',
    styles: ``,
    standalone: false,
})
export class GuidanceDrawerComponent implements OnInit {
    public title: string = null;

    public visible: boolean = false;

    public width: string = '800px';

    public resourceNotFound: boolean = false;

    private _cache: { [key: string]: string } = {};

    public initialized: boolean = false;

    public error: boolean = false;

    @ViewChild('divResource')
    public divResource: ElementRef;

    private _index: IGuidanceSettings[] = [];

    public constructor(
        private _guidance: GuidanceService,
        private _http: HttpClient
    ) {}

    public ngOnInit(): void {
        this._guidance.lookingFor.subscribe({
            next: (context) => {
                this.visible = true;
                this.width = context.width ?? this.width;
                this._lookingFor(context);
            },
        });
    }

    private _lookingFor(context: GuidanceContext): void {
        if (this.initialized) {
            setTimeout(() => this._loadGuidance(context.resource));
        } else {
            this._http.get('assets/guidance/index.json').subscribe({
                next: (index: IGuidanceSettings[]) => {
                    this._index = index;
                    this.initialized = true;
                    setTimeout(() => this._loadGuidance(context.resource));
                },
                error: () => {
                    this.error = true;
                },
            });
        }
    }

    private _loadGuidance(resource: string): void {
        this.resourceNotFound = false;

        const element = this.divResource.nativeElement;
        const settings: IGuidanceSettings = this._index.find(
            (i) => i.resource == resource
        );

        this.title = null;

        if (settings) {
            this.title = settings.title;
            if (this._cache.hasOwnProperty(resource)) {
                element.innerHTML = this._cache[resource];
            } else {
                const url = `/assets/guidance/${resource}.html`;

                this._http.get(url, { responseType: 'text' }).subscribe({
                    next: (content) => {
                        element.innerHTML = content;
                        this._cache[resource] = content;
                    },
                    error: () => {
                        this.resourceNotFound = true;
                    },
                });
            }
        } else {
            this.resourceNotFound = true;
        }
    }
}
